import React from 'react';
import { Eye, DollarSign, Award } from 'lucide-react';

const WhyChooseCard: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-blue-800 to-blue-900 rounded-2xl p-6 text-white shadow-2xl border border-blue-700">
      <div className="text-center">
        <h3 className="text-2xl font-bold mb-2">Why Choose Colorado First Plumbing?</h3>
        <p className="text-lg text-blue-100 mb-4">
          We're the ONLY Colorado plumber showing exact prices online - see what you'll pay before you call!
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div className="bg-white/10 rounded-lg p-4 backdrop-blur-sm">
            <div className="flex items-center justify-center mb-2">
              <Eye size={24} className="text-white" />
            </div>
            <h4 className="font-bold text-white mb-1">See Exact Prices</h4>
            <p className="text-sm text-blue-100">No estimates or ranges - exact costs shown online</p>
          </div>
          
          <div className="bg-white/10 rounded-lg p-4 backdrop-blur-sm">
            <div className="flex items-center justify-center mb-2">
              <DollarSign size={24} className="text-white" />
            </div>
            <h4 className="font-bold text-white mb-1">Documented Work</h4>
            <p className="text-sm text-blue-100">Over 300 Actual Plumbing Videos Across Social Media</p>
          </div>
          
          <div className="bg-white/10 rounded-lg p-4 backdrop-blur-sm">
            <div className="flex items-center justify-center mb-2">
              <Award size={24} className="text-white" />
            </div>
            <h4 className="font-bold text-white mb-1">Master Plumber</h4>
            <p className="text-sm text-blue-100">Licensed professional, not salesmen</p>
          </div>
        </div>
        
        {/* Incorporate the trust indicators from SocialProofBar */}
        <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4 text-white text-sm">
          <div className="flex items-center justify-center space-x-2">
            <div className="w-4 h-4 bg-green-600 rounded-full flex items-center justify-center">
              <span className="text-white text-xs">✓</span>
            </div>
            <span>Licensed Master Plumber</span>
          </div>
          <div className="flex items-center justify-center space-x-2">
            <div className="w-4 h-4 bg-green-600 rounded-full flex items-center justify-center">
              <span className="text-white text-xs">✓</span>
            </div>
            <span>Woman-Owned Business</span>
          </div>
          <div className="flex items-center justify-center space-x-2">
            <div className="w-4 h-4 bg-green-600 rounded-full flex items-center justify-center">
              <span className="text-white text-xs">✓</span>
            </div>
            <span>BBB A+ Rating</span>
          </div>
          <div className="flex items-center justify-center space-x-2">
            <div className="w-4 h-4 bg-green-600 rounded-full flex items-center justify-center">
              <span className="text-white text-xs">✓</span>
            </div>
            <span>18,000+ Jobs Completed</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseCard;